// @flow
import type { SampleList } from "../../lib/OnlineTypes";
import React from "react";
import Samples from "../sample_reporting/Samples";
import SampleSearch from "./SampleSearch";
import ExportActionBar from "../sample_reporting/ExportActionBar";
import { MinimalContainer } from "../../styles/Theme";
import _ from "underscore";
import ReceivingToolbar from "./ReceivingToolbar";

type Props = {
  laboratory_company_id: ?number,
  canFindCompany: ?boolean,
  form_params: ?Object,
  forceSearch: boolean,
  sample_id: ?number,
  initialFormParams: ?object,
  hideSearchForm: ?boolean,
};

type State = {
  sample_list: SampleList,
  selectedSampleIds: Object,
  generation: number,
};

export default class LaboratorySampleSearch extends React.Component<Props, State> {
  state = {
    sample_list: null,
    selectedSampleIds: {},
  };

  static defaultProps = {
    initialFormParams: {},
    hideSearchForm: false,
  };

  setSampleList = (sample_list: SampleList) =>
    this.setState({
      sample_list,
      selectedSampleIds: {},
    });

  groupedByLaboratoryBranch = (): SampleList => {
    const array = [];
    const { sample_list } = this.state;
    const grouped = _.groupBy(
      sample_list.samples,
      (sample) => sample.laboratory_sample.company_branch_id
    );
    for (var key in grouped) {
      array.push([
        key,
        {
          samples: grouped[key],
          columns: sample_list.columns,
        },
      ]);
    }
    return array;
  };

  highlightSample = (sample) => {
    return sample.laboratory_sample.received_at;
  };

  render() {
    const {
      laboratory_company_id,
      canFindCompany,
      forceSearch,
      initialFormParams,
      hideSearchForm,
    } = this.props;
    const { sample_list, selectedSampleIds } = this.state;
    return (
      <div>
        <SampleSearch
          ref={(ref) => (this.searchForm = ref)}
          laboratory_company_id={laboratory_company_id}
          onSearch={this.setSampleList}
          canFindCompany={canFindCompany}
          runSearch={forceSearch}
          initialFormParams={initialFormParams}
          hideForm={hideSearchForm}
        />

        {sample_list &&
          this.groupedByLaboratoryBranch().map((arr) => {
            const branchId = arr[0];
            const sampleList = arr[1];
            return (
              <div style={{ marginTop: 20 }}>
                <h3>{sampleList.samples[0].laboratory_sample.branch_name}</h3>
                <ReceivingToolbar
                  sampleIds={selectedSampleIds[branchId]}
                  receivingBranchId={branchId}
                  onChange={() => this.searchForm.performLastSearch()}
                />
                <Samples
                  sample_list={sampleList}
                  highlight={this.highlightSample}
                  onSampleSelectChange={(sampleIds) => {
                    selectedSampleIds[branchId] = sampleIds;
                    this.setState({
                      selectedSampleIds,
                    });
                  }}
                  ToolbarComponent={ExportActionBar}
                  reloadData={() => this.searchForm.findSamples()}
                  showAttributes={false}
                  clientView={false}
                />
              </div>
            );
          })}
      </div>
    );
  }
}
